import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { of, map, catchError, throwError, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KioskPINService {
  private apiURL: string = environment.apiURL
  private pinEndPoint: string = environment.PINEndPoint
  private http = inject(HttpClient)

  password = signal(null)
  error = signal(false)

  PINRessource = rxResource({ 
    request: () => this.password(),
    loader: ( {request} ) => {
      this.error.set(false)
      if(request === null) return of (null)
      return this.http.post<boolean>(this.apiURL + this.pinEndPoint, {'password': request}).pipe(
      catchError(err => {
        this.error.set(true)
        return throwError(() => err); // <-- re-throw to trigger error state
      }))
    }
  })  
}
